import UserInfo from 'src/models/UserInfo';

class UserInfoService {
  static setInfo(
    accessToken: string,
    refreshToken: string,
    userInfo?: string,
    loginToken?: string
  ) {
    sessionStorage.setItem('access_token', accessToken);
    sessionStorage.setItem('refresh_token', refreshToken);
    if (userInfo) {
      sessionStorage.setItem('user_info', JSON.stringify(userInfo));
    }
    if (loginToken) {
      sessionStorage.setItem('login_token', loginToken);
    }
  }

  static getAccessToken(): string {
    return sessionStorage.getItem('access_token');
  }

  static getRefreshToken(): string {
    return sessionStorage.getItem('refresh_token');
  }

  static setLoginToken(loginToken: string) {
    sessionStorage.setItem('login_token', loginToken);
  }

  static getLoginToken(): string {
    return sessionStorage.getItem('login_token');
  }

  static clearInfo() {
    sessionStorage.removeItem('user_info');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('login_token');
  }

  static setUserInfo(userInfo) {
    sessionStorage.setItem('user_info', JSON.stringify(userInfo));
  }

  static getUserInfo(): UserInfo {
    try {
      const userInfo: UserInfo = JSON.parse(
        sessionStorage.getItem('user_info')
      );
      return userInfo;
    } catch (err) {
      console.log('Parse UserInfo err', err);
      return null;
    }
  }
}

export default UserInfoService;
